module.exports = __webpack_public_path__ + "img/bg_custom1.c9b9fe64.jpg";